import { appName } from '../config/settings/app.settings';

const prefixKey = `${appName}/`;

const setLocalItem = (key: string, value: string) => {
  localStorage.setItem(prefixKey + key, value);
};

const getLocalItem = (key: string) => {
  return localStorage.getItem(prefixKey + key);
};

const removeLocalItem = (key: string) => {
  localStorage.removeItem(prefixKey + key);
};

const getStorageKeys = () => {
  return Object.keys(localStorage).filter((key) => key.startsWith(prefixKey));
};

const clearLocalStorage = () => {
  getStorageKeys().forEach((key) => {
    localStorage.removeItem(key);
  });
};

const clearAppStorage = () => {
  // leaving this in case we want to implement a session storage solution as well
  clearLocalStorage();
};

export { setLocalItem, getLocalItem, removeLocalItem, clearLocalStorage, clearAppStorage };
